// once we work on the functionality, the selectors will be created here
// sample code

import { createSelector } from 'reselect';
import { initState } from './reducer';

const atmLocationReducer = (state) => state.atmlocations || initState;

const atmLocationData = createSelector(atmLocationReducer, (cnter) => cnter.atmLocationData);
const isAtmLoading = createSelector(atmLocationReducer, (cnter) => cnter.isAtmLoading);

const isAtmAccessTokenSuccess = createSelector(atmLocationReducer, (cnter) => cnter.isAtmAccessTokenSuccess);


export default {
	atmLocationReducer,
	atmLocationData,
	isAtmLoading,

	isAtmAccessTokenSuccess,

};
